{
  "clear": "Wissen",
  "invalid": "(ongeldig)",
  "loading": "Laden...",
  "noResults": "Geen resultaten"
}
